// Generic case-insensitive substring matcher for admin list filtering.
//
// `fields` accepts a mix of:
//   - string keys (dot paths supported, e.g. `vendor.business_name`)
//   - functions that receive the item and return a string, array of strings,
//     or any value (objects are JSON-stringified, arrays are flattened)
//
// Returns true when `query` is empty/whitespace OR any resolved field contains
// the query as a case-insensitive substring.
const resolvePath = (item, path) => {
  if (!item || !path) return undefined;
  return path.split('.').reduce((acc, key) => {
    if (acc === null || acc === undefined) return undefined;
    return acc[key];
  }, item);
};

const toHaystackParts = (value) => {
  if (value === null || value === undefined) return [];
  if (Array.isArray(value)) return value.flatMap(toHaystackParts);
  if (typeof value === 'object') {
    try {
      return [JSON.stringify(value)];
    } catch (_err) {
      return [];
    }
  }
  return [String(value)];
};

export const matchesSearch = (item, query, fields) => {
  const q = (query || '').trim().toLowerCase();
  if (!q) return true;
  if (!item || !Array.isArray(fields)) return false;

  for (const field of fields) {
    const raw = typeof field === 'function' ? field(item) : resolvePath(item, field);
    const parts = toHaystackParts(raw);
    for (const part of parts) {
      if (part && part.toLowerCase().includes(q)) return true;
    }
  }
  return false;
};

export default matchesSearch;
